<template>
    <div>
        <div class="server-mod">
            <div class="cloud-plan">
                <nav>
                    <ul>
                        <li @click="()=>tabChange(true)" :class="isActivPlans?'active':''">{{ $tc("dashboard.active_plan") }}</li>
                        <li @click="()=>tabChange(false)" :class="!isActivPlans?'active':''">{{$tc("dashboard.inactive_plan")}}</li>
                    </ul>
                </nav>
                <plan-card
                    :subscribes='subscribes'
                    :deviceList='deviceList'
                    :cloudProductLists='productList'
                    :is-active-plans='isActivPlans'
                    @refresh='refresh'
                    v-if='subscribes.length!==0'
                />
                <div class='no-data' v-else>
                    <img :src="EmptyImage"/>
                    <p class="text">{{$t('dashboard.noData')}}</p>
                    <router-link
                        v-if="!activeSubscribes.length && showContent"
                        id="cloudPlanLink"
                        class="ui-button primary-button short-button"
                        ga-label="Dashboard subscribe"
                        :to="{path: '/user/subscribe-plan/'}">{{ $t("dashboard.server_plan") }}</router-link>
                </div>
                <div class="plan-history">
                    <div
                        @click="handlePaymentHistory"
                    >
                        <router-link
                            to="/user/cloud-plan-payment-history/"
                            class="ui-link"
                        >
                            <span class="text">{{ $t( 'dashboard.payment_history' ) }}</span>
                            <span class="ui-icon icon-icon_arrow-right"></span>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { getUserUsage, getDeviceTotal, getDeviceIdsHasVideo } from '@/api/cloud';
// import { getDeviceIdsHasVideo } from '@/api/gallery';
import { getDeviceList } from '@/api/device';
import { getIccidByUid, getSubscriptions } from '@/api/subscriptions';
import {  getCloudProductLists, getPlanById } from '@/api/cart';
import { deliver as deliverStatus } from '@/config/status';
import { unfoldError } from '@/common/js/notice';
import { listToString } from '@/api/s3Config';
import nprogress from 'nprogress';
import planCard from '@/components/PlanCards/index.vue';
import { config } from 'CONFIG';
import { ESeriesCategory, EAccountDeviceStatus, EDeviceInfoModule, IDeviceModelGroup, IPlanSeries } from '@reolink-cloud/interface';
import EmptyImage from 'IMAGE/dashboard/noDevice.webp';
import reolinkGa from '@/common/js/gtagPageview';

type TGetCloudProductList = Awaited<ReturnType<typeof getCloudProductLists>>;

export default Vue.extend({

    components: {

        planCard

    },

    data () {

        return {
            productList: {} as TGetCloudProductList['cloudProductLists'],
            storageLocList: {} as TGetCloudProductList['storageLocList'],
            deviceList: [] as any[],
            videoTotal: 0,
            showContent: false,
            isActivePlans: true,
            activeSubscribes: [] as any[],
            inactiveSubscribes: [] as any[],
            subsRefresh: 0,
            initialized: false,
            config,
            isActivPlans: true,
            EmptyImage,
            richNotifServices: {} as Record<string, any>

        };

    },

    async created () {

        const getProductListRes = await getCloudProductLists({ lang: this.lang }, 'all', 'dashboard' );

        const data = getProductListRes.cloudProductLists;
        // 获取机型的详细信息，包括图片，链接，名称
        Object.keys( data.deviceModelGroups ).map( group => {

            const models = data.deviceModelGroups[group].models;
            const modelArr: IDeviceModelGroup['modelsDetails'] = [];
            for ( const model of models ) {

                if ( !modelArr.find( item => item.key === model )) {

                    modelArr.push({
                        image: `${data.deviceModels[model].styles.imageUrl ?? ''}`,
                        link: `${data.deviceModels[model].styles.link ?? config.reolink}`,
                        text: data.deviceModels[model]?.title ?? '',
                        visible: data.deviceModels[model]?.visible ?? 'disabled',
                        key: model
                    });

                }

            }

            data.deviceModelGroups[group].modelsDetails = modelArr;

        });
        this.productList = getProductListRes.cloudProductLists;
        this.storageLocList = getProductListRes.storageLocList;
        await this.getDevices();
        await this._getStorageSub();
        this.showContent = true;

        await this.getVideoCount();
        this.initialized = true;

        nprogress.done();

    },

    computed: {

        howToBindUrl (): string {

            return this.$tc( 'dashboard.bind_url' );

        },

        videoNum (): string {

            return this.videoTotal === 0 ? this.$tc( 'dashboard.no_video' ) : ( this.videoTotal + ' ' + this.$tc( 'dashboard.video' ) + ( this.videoTotal > 1 ? 's' : '' ));

        },

        lang(): string {

            return this.$store.getters.lang;

        },
        subscribes(): unknown[] {

            return this.isActivPlans ? this.activeSubscribes : this.inactiveSubscribes;

        }

    },

    methods: {
        getHref (): string {

            return window.location.href;

        },

        /**
         * 获取my cloud plan版块的信息
         *
         * 并且获取设备与当前套餐的绑定状态
         */
        async _getStorageSub (): Promise<void> {

            /**
             * 先获取当前的订阅信息
             *
             * 如果当前没有订阅信息，则直接返回
             */

            try {

                const activeSub = await getSubscriptions( 'active', 0, { checkActionConfig: 'true' });

                let year = 365 * 24 * 60 * 60 * 1000;
                let currentTimeStamp = new Date().getTime();
                const inactiveSub = await getSubscriptions( 'inactive', currentTimeStamp - year, { checkActionConfig: 'true' });

                if ( !activeSub && !inactiveSub ) {

                    return;

                }

                await this.getSubscribes( 'active', activeSub );
                await this.getSubscribes( 'inactive', inactiveSub );

                const newDeviceList: any[] = [];
                /**
                 * pending payment时不显示套餐内容
                 */
                for ( let device of this.deviceList ) {

                    for ( let sub of this.activeSubscribes ) {

                        if ( device.subscription === sub.subId ) {

                            device.subName = sub.title;
                            device.planTitle = sub.planTitle;

                        }

                    }

                    newDeviceList.push( device );

                }
                this.deviceList = newDeviceList;

            } catch ( err ) {

                console.error( err );

            }

        },

        async getSubscribes ( type, list ): Promise<void> {

            const subscribes: any[] = [];// 清空当前列表
            for ( let sub of list.items ) {

                let series: IPlanSeries;
                if ( typeof this.productList.plans[`${sub.plan}`] === 'undefined' ) {

                    let res = await getPlanById( sub.plan, this.$store.getters.lang );
                    this.productList.plans[`${sub.plan}`] = res.plan as any;
                    this.productList.plans[`${sub.plan}`].style['plan.display_color'] = res.series.style['series.display_color'];
                    this.productList.plans[`${sub.plan}`].title = res.series.i18n.name;
                    this.productList.planSeries[`${res.plan.seriesKey}`] = res.series as any;
                    series = res.series;
                    sub.plan = res.plan;
                    sub.planTitle = res.series.i18n.name;

                } else {

                    sub.plan = this.productList.plans[`${sub.plan}`];
                    series = this.productList.planSeries[`${sub.plan.seriesKey}`];

                }
                if ( sub.plan.portablePlan !== '0' && typeof this.productList.plans[sub.plan.portablePlan] === 'undefined' ) {

                    let res = await getPlanById( sub.plan.portablePlan, this.$store.state.lang.lang );

                    this.productList.plans[`${res.plan.id}`] = res.plan as any;
                    this.productList.plans[`${res.plan.id}`].style['plan.display_color'] = res.series.style['series.display_color'];
                    this.productList.plans[`${res.plan.id}`].title = res.series.i18n.name;
                    this.productList.planSeries[`${res.series.key}`] = res.series as any;

                }
                if ( ![ESeriesCategory.CLOUD_STORAGE_PLAN, ESeriesCategory.CLOUD_RICH_NOTIFICATION_PLAN].includes( series.category )) {

                    continue;

                }

                let availableModel = this.productList.deviceModelGroups[series.deviceGroup].modelsDetails.map( item => item.text );
                let deviceList: any[] = [];
                let deviceUidList: any[] = [];
                let deviceRichCount = 0;
                const planRichLimit = sub.plan?.style?.['rich_notification.daily_limit'] ?? 0;
                let deviceRichLimit = planRichLimit;
                if ( series.category === ESeriesCategory.CLOUD_RICH_NOTIFICATION_PLAN && this.richNotifServices[sub.id] ) {

                    const svc = this.richNotifServices[sub.id];
                    deviceRichLimit = svc.dailyRichNotificationLimit ?? planRichLimit;
                    deviceRichCount = svc.dailyRichNotificationCount ?? 0;

                }
                for ( let device of this.deviceList ) {

                    if ( device.subscription === sub.id ) {

                        if ( device.status === 'associated' ) {

                            // 空间使用量跟随关联设备变化
                            deviceUidList.push( device.uid );
                            deviceList.push( device );

                        }

                    }

                }
                let size: string | number = '0.00';
                let usedSpace = 0;
                if ( deviceUidList.length !== 0 ) {

                    try {

                        const usage = await getUserUsage( deviceUidList );

                        for ( let item of usage.items ) {

                            usedSpace += item.usedSpace;

                        }

                        /**
                        * 已使用的容量
                        */
                        usedSpace = usedSpace > sub.plan['style']['cloud_storage.space_capacity'] ? sub.plan['style']['cloud_storage.space_capacity'] : usedSpace;
                        size = ( usedSpace / 1024 / 1024 / 1024 ).toFixed( 2 );
                        if ( size === '0.00' && usedSpace ) {

                            size = 0.01;

                        }

                    } catch ( err ) {

                        console.log( err );

                    }

                }

                if ( typeof sub.plan !== 'undefined' ) {

                    let regions = this.productList.storageRegions;

                    let productSupported = this.productList.deviceModelGroups[series.deviceGroup].modelsDetails.filter( item => item.visible === 'enabled' );
                    let productSupportedString = '';
                    if ( !productSupported?.length ) {

                        productSupportedString = '';

                    } else {

                        let texts = productSupported.map( item => item.text );
                        texts = Array.from( new Set( texts ));
                        if ( !texts?.length ) {

                            productSupportedString = '';

                        } else {

                            productSupportedString = listToString( texts, this.$store.state.lang.lang );

                        }

                    }
                    let maxSpace = ( sub.plan['style']['cloud_storage.space_capacity'] / 1024 / 1024 / 1024 ).toFixed( 2 );
                    subscribes.push({
                        subId: sub.id,
                        plan: {
                            ...sub.plan,
                            series,
                        },
                        planId: sub.plan.id,
                        defaultVideoHistory: sub.defaultVideoHistory,
                        portablePlanId: sub.plan.portablePlan,
                        planStatus: sub.plan.status,
                        planTitle: sub.plan.title || sub.planTitle,
                        title: typeof sub.title === 'undefined' ? '' : sub.title,
                        color: sub.plan.style['plan.display_color'],
                        maxCamera: sub.plan.style['cloud_storage.max_device_quantity'],
                        lifeTime: sub.plan.style['cloud_storage.video_lifetime'],
                        limitations: sub.plan.limitations,
                        usedSpaceAccurate: usedSpace,
                        usedSpace: size,
                        maxSpace: maxSpace,
                        percent: Number( size ) / ( maxSpace === '0.00' ? 1 : Number( maxSpace )) * 100,
                        endingAt: sub.endingAt,
                        status: sub.status,
                        switchable: sub.nextSwitchableAt === 0 || sub.nextSwitchableAt < new Date().getTime(),
                        nextSwitchableAt: sub.nextSwitchableAt,
                        expiredAt: sub.expiredAt,
                        price: sub.plan.cycle.salePrice,
                        show: sub.status !== deliverStatus.PENDING,
                        cycle: sub.plan.cycle,
                        style: sub.plan.style,
                        deviceList: deviceList,
                        availableModel,
                        storageRegion: regions[series.storageRegion]?.i18n.name,
                        productSupportedString: productSupportedString,
                        legacyTag: sub.legacyTag,
                        autoRenewal: sub.autoRenewal,
                        nextBillingAt: sub.nextBillingAt,
                        countryGroups: series.countryGroups,
                        freePlanTrack: sub.freePlanTrack,
                        actionConfig: sub.actionConfig,
                        dailyRichNotificationLimit: deviceRichLimit,
                        dailyRichNotificationCount: deviceRichCount
                    });

                }

            }
            this[`${type}Subscribes`] = subscribes.sort(( a, b ) => b.endingAt - a.endingAt );// 赋值当前列表

        },

        handlePaymentHistory() {

            reolinkGa.sendSimpleEvent( 'Dashboard-My Payment History' );

        },

        async getDevices (): Promise<void> {

            try {

                const esimProfile = await getIccidByUid();
                this.deviceList = ( await getDeviceTotal()).filter( device => !esimProfile.some( esim => esim.uid === device.uid ) && device.boundStatus === 'bound' );

            } catch ( err ) {

                console.error( err );
                unfoldError( 'errors.server_error', 10000 );

            }

            try {

                const richUids = this.deviceList.filter( device => {

                    if ( device.status !== 'associated' ) return false;
                    const plan = this.productList.plans?.[device.plan];
                    if ( !plan ) return false;
                    return this.productList.planSeries?.[plan.seriesKey]?.category === ESeriesCategory.CLOUD_RICH_NOTIFICATION_PLAN;
                
                }).map(( device: any ) => device.uid );
                if ( richUids.length > 0 ) {

                    const res = await getDeviceList({
                        uids: [ ...new Set( richUids )],
                        statuses: [EAccountDeviceStatus.BOUND],
                        includes: [EDeviceInfoModule.CLOUDSERVICES],
                    });
                    this.richNotifServices = res.cloudServices ?? {};

                }

            } catch ( err ) {

                console.error( err );

            }

            for ( let device of this.deviceList ) {

                if ( typeof device.modelTitle === 'undefined' ) {

                    Object.keys( this.productList.deviceModels ).map( key => {

                        if ( this.productList.deviceModels[key].title === device.model ) {

                            device.modelTitle = this.productList.deviceModels[key].title;

                        }

                    });

                }

            }

        },

        async refresh (): Promise<void> {

            await this.getDevices();
            await this._getStorageSub();
            this.subsRefresh++;

        },

        async getVideoCount (): Promise<void> {

            // 获取60天内的视频数量
            try {

                let devicesId = await getDeviceIdsHasVideo();
                let devicesUidArr = devicesId.map(( item ) => item.uid );

                if ( devicesUidArr.length !== 0 ) {

                    let videosData = await getUserUsage( devicesUidArr );
                    this.videoTotal = videosData.items.reduce(( pre, cur ) => ( pre + cur.videoQty ), 0 );

                }

            } catch ( error ) {

                console.log( error );
                unfoldError( 'errors.server_error', 10000 );

            }

        },

        tabChange ( e: boolean ): void {

            this.isActivPlans = e;

        },

    }

});
</script>

<style type="text/css" lang="less" scoped>

    .dashboard-mod .server-mod{
        .no-content {
            color: #777;
            display: inline-block;
            vertical-align: top;
        }
        .num{
            font-weight: 500;
            color: @theme;
            font-size: .18rem;
            vertical-align: middle;
        }
        .videos,.plans,.devices{
            &>label{
                flex-shrink: 0;
                width: 1.95rem;
                font-size: .22rem;
                font-weight: 500;
                color: #333;
                vertical-align: middle;
                line-height: 1.2;
            }
        }
        .videos {
            margin-bottom: .6rem;
        }
        &>ul>li {
            display: flex;
            @media @mobile{
                flex-direction: column;
            }
        }

        .remark{
            margin-left: 1.85rem;
            margin-top: .3rem;
            color: #dd4429;
            font-size: .16rem;
        }
        .videos-manager {
            display: flex;
            flex-direction: column;
            justify-content: center;
        }
        .pin-text {
            font-weight: 500;
            font-size: .18rem;
            vertical-align: middle;
            margin-top: .2rem;
        }
        .pin-text-link {
            color: #333333;
            text-decoration: underline;
        }
    }

    .cloud-plan{
        display: inline-block;
        vertical-align: top;
        text-align: center;
        width:100%;
        nav ul{
            display: flex;
            gap: 24px;
            margin-top: 24px;
            margin-bottom: 24px;
            width: 100%;
            overflow: auto;
            @media @mobile{
                gap: 12px;
                position: relative;
                width: calc( 100% + 20px);
                -ms-overflow-style: none;  /* IE and Edge */
                scrollbar-width: none;  /* Firefox */
                &::-webkit-scrollbar {
                    display: none;
                }
            }
            li{
                border: 1px solid @font_tertiary;
                border-radius: 8px;
                color: @font_secondary;
                cursor: pointer;
                padding: 10px 20px;
                font-weight: 500;
                font-size: 16px;
                white-space: nowrap;
                &:last-of-type{
                    @media @mobile{
                        margin-right: 20px;
                    }
                }
                &.active{
                    background-color: @b_1;
                    border-color: @b_2;
                    color: @b_6;
                }
            }
        }
        .plan-history{
            border-top:1px solid @line;
            margin-top: 31px;
            margin-bottom: 39px;
            padding-top: 12px;
            text-align: left;
            @media @mobile{
                padding-left: .3rem;
                margin-bottom: .4rem;
            }
        }
    }

    #cloudPlanLink{
        margin-bottom: .4rem;
    }

    @media @mobile {

        .cloud-plan{
            text-align: left;
        }

        .cloud-plan-name .content{
            margin-left: -3rem;
        }

        .devices .status{
            width: 1.6rem;
        }

        .dashboard-mod .server-mod{
            padding: 0;
            & > ul{
                background: #f7f8f9;
                & > li{
                    background: #fff;
                }
            }
            .videos,.plans,.devices{
                & > label{
                    width:unset;
                    font-size: .32rem;
                    line-height: 1.2;
                    font-weight: 500;
                    display: block;
                    margin-bottom: .3rem;
                }
            }
            .videos{
                padding: 0 .3rem .4rem;
                margin:0;
            }
            .plans,.devices{
                margin-top: .1rem;
                padding-top: .6rem;
            }
            .plans > *{
                padding: 0 .3rem;
            }
            .plans .cloud-plan{
                padding: 0;
                border-radius: 0;
            }
            .devices{
                margin-top: 0;
            }
            .devices > *{
                padding: 0 .3rem;
                margin-right: 0;
            }
            .num {
                font-size: .26rem;
                line-height: 1.3;
                font-family: @font_02;
                padding: 0;
            }
            .pin-text {
                font-size: .26rem;
                line-height: 1.3;
            }
            .link {
                margin-bottom: .3rem;
                padding-left: 0;
                &.bottom-lab-link {
                    padding-left: 0.52rem;
                }
                .lab-icon {
                    font-size: 0.4rem;
                }
                & + .link {
                    margin-top: 0.3rem;
                }
            }
            .remark{
                font-size: .26rem;
                margin-left: 0;
            }
        }

        #cloudPlanLink{
            line-height: .78rem;
            padding: 0 .45rem;
            font-size: 14px;
        }
    }
.tabBox{
    margin-bottom:.24rem;
    &.noData{
        margin-bottom: .4rem;
    }
    @media @mobile{
        margin-left: 0.3rem;
        margin-bottom: .4rem;
    }
}
.server-mod .plans .cloud-plan .tabBox{
    width: fit-content;
}
.no-data{
    margin-bottom: 94px;
    margin-top: 85px;
    text-align: center;
    font-size: .16rem;
    line-height: 1.6;
    color:#333;
    .text{
        margin-top: 8px;
        margin-bottom: 24px;
        font-size: 20px;
        font-weight: 500;
        color: @font_secondary;
        @media @mobile{
            font-size: 16px;
        }
    }
}
</style>
